<div id="bisherigeBetrieblicheVerhaeltnisseAngaben">

  <h2
    class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.BISHERIGEBETRIEBLICHEVERHAELTNISSE.TITEL' | translate }}</h2>

  <div class="mb-5x">
    <common-ui-bisherige-betriebliche-verhaeltnisse-vortaetigkeit [(data)]="data" [readonly]="readonly">
    </common-ui-bisherige-betriebliche-verhaeltnisse-vortaetigkeit>
  </div>

  <div *ngIf="data?.bisherigeTaetigkeitVorhanden" class="mb-5x">
    <h2
      class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.BISHERIGEBETRIEBLICHEVERHAELTNISSE.STEUERNUMMER_TITEL' | translate }}</h2>
    <common-ui-steuernummer [(data)]="data.steuernummer" [readonly]="readonly"></common-ui-steuernummer>
  </div>

</div>
